import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import Layout from '@/Shared/Layout';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
import { Link } from '@inertiajs/inertia-vue3';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter,
    Link: Link
  },
  layout: Layout,
  props: {
    tenantList: {
      type: Object,
      "default": {}
    },
    leadStatuses: {
      type: Object,
      "default": {}
    }
  },
  data: function data() {
    return {
      popupTenantList: {},
      startDate: "",
      endDate: "",
      selectedTenant: "",
      leadStatus: "",
      showTransfer: false,
      leadList: [],
      isLoadingRules: false,
      activeLead: [],
      leadCount: 0,
      currentPage: 1,
      showTransferAllBtn: false,
      showTransferAll: false,
      transferAllLead: []
    };
  },
  methods: {
    updateActiveLeadTarget: function updateActiveLeadTarget() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var i, targetdata;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.activeLead.target_tenants = JSON.parse(JSON.stringify(_this.activeLead.existing_tenants));
                i = 0;
                for (i in _this.activeLead.target_data) {
                  targetdata = _this.activeLead.target_data[i].split(':');
                  if (!_this.activeLead.target_tenants.includes(targetdata[0])) {
                    _this.activeLead.target_tenants.push(targetdata[0]);
                  }
                }
                _this.updateTargetDropddown();
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    saveTransfer: function saveTransfer() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$store.loading = true;
                _context2.next = 3;
                return axios.post('/transfer/save_transfer', {
                  'leadData': _this2.activeLead
                });
              case 3:
                res = _context2.sent;
                ElMessage({
                  showClose: true,
                  message: res.data.message,
                  type: res.data.status
                });
                _this2.cancelTransfer();
                _this2.showLeads();
                _this2.$store.loading = false;
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    showLeads: function showLeads() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var resetpagination, requestData, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                resetpagination = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                _this3.isLoadingRules = true;
                requestData = {
                  "getCount": resetpagination,
                  "page": _this3.currentPage,
                  "startDate": _this3.startDate,
                  "endDate": _this3.endDate,
                  "tenant": _this3.selectedTenant,
                  "leadStatus": _this3.leadStatus,
                  "tenantList": _this3.tenantList
                };
                _context3.next = 5;
                return axios.post('/transfer/leads', requestData);
              case 5:
                res = _context3.sent;
                if (res.data.status == 'success') {
                  _this3.leadList = res.data.rules;
                  if (_this3.selectedTenant.length && _this3.leadList.length) {
                    _this3.showTransferAllBtn = true;
                  } else {
                    _this3.showTransferAllBtn = false;
                  }
                  if (resetpagination) {
                    _this3.currentPage = 1;
                    _this3.leadCount = res.data.leadCount;
                  }
                }
                _this3.isLoadingRules = false;
              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    downloadLeads: function downloadLeads() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var requestData, _res, resData, url, link;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _this4.$store.loading = true;
                requestData = {
                  "startDate": _this4.startDate,
                  "endDate": _this4.endDate,
                  "tenant": _this4.selectedTenant,
                  "leadStatus": _this4.leadStatus,
                  "tenantList": _this4.tenantList,
                  "downloadLeads": true
                };
                _context4.next = 5;
                return axios.post('/transfer/leads', requestData, {
                  responseType: 'blob'
                });
              case 5:
                _res = _context4.sent;
                resData = _res.data;
                url = window.URL.createObjectURL(new Blob([resData]));
                link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'lead_list.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                _this4.$store.loading = false;
                _context4.next = 20;
                break;
              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](0);
                res = _context4.t0.response;
              case 20:
                _context4.prev = 20;
                _this4.$store.loading = false;
                return _context4.finish(20);
              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 17, 20, 23]]);
      }))();
    },
    updateTargetDropddown: function updateTargetDropddown() {
      this.popupTenantList = JSON.parse(JSON.stringify(this.tenantList));
      for (var i in this.popupTenantList) {
        var tenantId = this.popupTenantList[i].value;
        for (var j in this.popupTenantList[i].children) {
          if (tenantId == this.activeLead.tenant_id || Array.prototype.includes.call(this.activeLead.target_tenants, tenantId) && !Array.prototype.includes.call(this.activeLead.target_data, this.popupTenantList[i].children[j].value) || Array.prototype.includes.call(this.activeLead.existing_tenants, tenantId)) {
            this.popupTenantList[i].children[j].disabled = true;
          }
        }
      }
      return true;
    },
    transferLead: function transferLead(leadData) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.activeLead = JSON.parse(JSON.stringify(leadData));
                _context5.next = 3;
                return _this5.updateTargetDropddown();
              case 3:
                _this5.showTransfer = true;
              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    cancelTransfer: function cancelTransfer() {
      this.showTransfer = false;
    },
    pageChange: function pageChange(current_page) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.currentPage = current_page;
                _context6.next = 3;
                return _this6.showLeads();
              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    showTransferAllPopup: function showTransferAllPopup() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.showTransferAll = true;
              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    saveTransferAll: function saveTransferAll() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var res;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.$store.loading = true;
                _context8.next = 3;
                return axios.post('/transfer/save_transfer_all', {
                  'transferData': _this8.transferAllLead,
                  "startDate": _this8.startDate,
                  "endDate": _this8.endDate,
                  "tenant": _this8.selectedTenant,
                  "leadStatus": _this8.leadStatus
                });
              case 3:
                res = _context8.sent;
                ElMessage({
                  showClose: true,
                  message: res.data.message,
                  type: res.data.status
                });
                _this8.cancelTransferAll();
                _this8.showLeads();
                _this8.$store.loading = false;
              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    cancelTransferAll: function cancelTransferAll() {
      this.showTransferAll = false;
    }
  }
};